import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'context/authContext';
import { ROLE_TYPES } from 'api/constants';

export const IsAuthenticated = () => {
  const { auth, role } = useAuth();

  if (auth) {
    return <Navigate to="/dashboard" />;
  }

  return <Navigate to={role === ROLE_TYPES.client ? '/login' : '/'} />;
};
